export const FEATURE_ROW_HEIGHT = 40;
export const FEATURE_ROW_LABEL_WIDTH = 260;
export const FEATURE_ROW_LABEL_FONT_SIZE = 14;
export const FEATURE_ROW_GAP = 10;
export const FEATURE_TAG_HEIGHT = 30;
export const FEATURE_TAG_PADDING = 10;
export const FEATURE_TAG_FONT_SIZE = 12;
export const FEATURE_TAG_RADIUS_CSS = "8px";
